require('new_design/desktop/favorites');
